<template>
    <nav :class="{ 'layout-sidebar': true, 'is-active': !getMenuToggle }">
        <div id="accordion" class="sidebar-content">
            <a class="logo" href="/">
                {{ $t('words.kollus_live_cms') }}
            </a>
            <div class="sidebar-group">
                <a id="headingChannel"
                   :aria-expanded="in_channel_menu"
                   :class="{'sidebar-title': true, 'list-group-itm-action': true, 'list-group-ite-secondary': true, 'collapsed': !in_channel_menu}"
                   aria-controls="collapseChannel"
                   data-target="#collapseChannel" data-toggle="collapse" @click="toggleGroup('channel')"
                >{{ $t('words.channel_manage') }}<i
                    :class="{'icon': true, 'icon-arrow-down-sm': true, 'is-rotate':  selectChannel}"></i></a>
                <div id="collapseChannel" :class="{collapse: true, show: in_channel_menu}"
                     aria-labelledby="headingChannel" data-parent="#accordion">
                    <router-link :to="{ name: 'cms-channels-list' }" class="sidebar-item">{{
                            $t('words.channel_list')
                        }}
                    </router-link>
                    <router-link v-if="haveServiceAccount" :to="{ name: 'cms-recording-files' }" class="sidebar-item">
                        {{ $t('words.recording_files') }}
                    </router-link>
                </div>
            </div>

            <div v-if="useFileToLive" class="sidebar-group">
                <a id="headingProgram"
                   :aria-expanded="in_program_menu"
                   :class="{'sidebar-title': true, 'list-group-itm-action': true, 'list-group-ite-secondary': true, 'collapsed': !in_program_menu}"
                   aria-controls="collapseProgram"
                   data-target="#collapseProgram" data-toggle="collapse" @click="toggleGroup('program')"
                >{{ $t('words.program_manage') }}<i
                    :class="{'icon': true, 'icon-arrow-down-sm': true, 'is-rotate':  selectProgram}"></i></a>
                <div id="collapseProgram" :class="{collapse: true, show: in_program_menu}"
                     aria-labelledby="headingProgram" data-parent="#accordion">
                    <router-link :to="{ name: 'cms-program-media-contents' }" class="sidebar-item">
                        {{ $t('words.contents_list') }}
                    </router-link>
                    <router-link :to="{ name: 'cms-program-wait-media-contents'}" class="sidebar-item">
                        {{ $t('words.wait_media_content_list') }}
                    </router-link>
                    <router-link :to="{ name: 'cms-program-schedules' }" class="sidebar-item">
                        {{ $t('words.program_schedule') }}
                    </router-link>
                </div>
            </div>
            <div v-if="haveServiceAccount" class="sidebar-group">
                <a id="headingStatistics"
                   :aria-expanded="in_statics_menu"
                   :class="{'sidebar-title': true, 'list-group-itemaction': true, 'list-group-iem-secondary': true , 'collapsed': !in_statics_menu}"
                   aria-controls="collapseStatistics"
                   data-target="#collapseStatistics" data-toggle="collapse" @click="toggleGroup('statics')"
                >{{ $t('words.statistics_manage') }}<i
                    :class="{'icon': true, 'icon-arrow-down-sm': true, 'is-rotate': selectStatics}"></i></a>

                <div id="collapseStatistics" :class="{collapse: true, show: in_statics_menu}"
                     aria-labelledby="headingStatistics" data-parent="#accordion">
                    <router-link v-if="haveManagerRight" :to="{ name: 'cms-statistics-channel' }" class="sidebar-item">
                        {{ $t('words.statistics_channel') }}
                    </router-link>
                    <router-link v-if="haveManagerRight" :to="{ name: 'cms-statistics-viewer-environment' }"
                                 class="sidebar-item">{{ $t('words.statistics_viewer_env') }}
                    </router-link>
                    <router-link v-if="haveManagerRight" :to="{ name: 'cms-statistics-storage-usage' }"
                                 class="sidebar-item">{{ $t('words.storage_usage') }}
                    </router-link>
                    <router-link v-if="haveManagerRight" :to="{ name: 'cms-statistics-service-usage' }"
                                 class="sidebar-item">{{ $t('words.statistics_service_usage') }}
                    </router-link>
                    <router-link :to="{ name: 'cms-statistics-service-logs' }" class="sidebar-item">
                        {{ $t('words.service_logs') }}
                    </router-link>
                    <router-link v-if="haveManagerRight && isKollusKindChatting" :to="{ name: 'cms-chatting-statistics-usage' }"
                                 class="sidebar-item">{{ $t('words.chatting_usage_statistics') }}
                    </router-link>
                </div>
            </div>

            <div class="sidebar-group">
                <a id="headingPreferences"
                   :aria-expanded="in_preferences_menu"
                   :class="{'sidebar-title': true, 'list-group-item-ation': true, 'list-group-item-seondary': true, 'collapsed': !in_preferences_menu}"
                   aria-controls="collapsePreferences"
                   data-target="#collapsePreferences" data-toggle="collapse"
                   @click="toggleGroup('preferences')"
                >{{ $t('words.preference') }}<i
                    :class="{'icon': true, 'icon-arrow-down-sm': true, 'is-rotate': selectPreferences}"></i></a>
                <div id="collapsePreferences" :class="{collapse: true, show: in_preferences_menu}"
                     aria-labelledby="headingSPreferences" data-parent="#accordion">
                    <router-link v-if="haveOwnerRight" :to="{ name: 'cms-preferences-general' }" class="sidebar-item">
                        {{ $t('words.basic_info') }}
                    </router-link>
                    <router-link v-if="haveServiceAccount" :to="{ name: 'cms-preferences-profile-groups' }"
                                 class="sidebar-item">{{ $t('words.profile') }}
                    </router-link>
                    <router-link v-if="haveOwnerRight" :to="{ name: 'cms-preferences-members' }" class="sidebar-item">
                        {{ $t('words.member_manage') }}
                    </router-link>
                    <router-link v-if="useDuplicateBlockPolicy && haveOwnerRight"
                                 :to="{ name: 'cms-preferences-duplicate_block_sessions' }"
                                 class="sidebar-item">{{ $t('words.duplicate_block') }}
                    </router-link>
                    <router-link v-if="useExclusivePlayerPolicy && useCaptureBlockPolicy && haveOwnerRight"
                                 :to="{ name: 'cms-preferences-capture_block_logs' }"
                                 class="sidebar-item">{{ $t('words.capture_block') }}
                    </router-link>
                </div>
            </div>
        </div>
    </nav>
</template>

<script>
import GlobalConfigMixin from '../mixin/GlobalConfigMixin';

export default {
    name: 'left-menu',
    mixins: [
        GlobalConfigMixin,
    ],
    data() {
        return {
            is_menu_toggle: false,
            in_channel_menu: false,
            in_program_menu: false,
            in_statics_menu: false,
            in_preferences_menu: false,
            selectChannel: false,
            selectProgram: false,
            selectStatics: false,
            selectPreferences: false,
        };
    },
    mounted() {
        this.in_channel_menu = this.inChannelMenu();
        this.in_program_menu = this.inProgramMenu();
        this.in_statics_menu = this.inStatisticsMenu();
        this.in_preferences_menu = this.inPreferencesMenu();
        if (this.in_channel_menu) {
            this.selectChannel = true;
        }
        if (this.in_program_menu) {
            this.selectProgram = true;
        }
        if (this.in_statics_menu) {
            this.selectStatics = true;
        }
        if (this.in_preferences_menu) {
            this.selectPreferences = true;
        }
    },
    methods: {
        toggleGroup(group) {
            if (group === 'channel') {
                this.selectChannel = !this.selectChannel;
                this.selectProgram = false;
                this.selectStatics = false;
                this.selectPreferences = false;
            }
            if (group === 'program') {
                this.selectChannel = false;
                this.selectProgram = !this.selectProgram;
                this.selectStatics = false;
                this.selectPreferences = false;
            }
            if (group === 'statics') {
                this.selectChannel = false;
                this.selectProgram = false;
                this.selectStatics = !this.selectStatics;
                this.selectPreferences = false;
            }
            if (group === 'preferences') {
                this.selectChannel = false;
                this.selectProgram = false;
                this.selectStatics = false;
                this.selectPreferences = !this.selectPreferences;
            }
        },
        inChannelMenu() {
            return this.currentRouteName === 'cms-channels-list' ||
                this.currentRouteName === 'cms-channels-view' ||
                this.currentRouteName === 'cms-channels-broadcast' ||
                this.currentRouteName === 'cms-recording-files';
        },
        inProgramMenu() {
            return this.currentRouteName === 'cms-program-media-contents' ||
                this.currentRouteName === 'cms-program-schedules' ||
                this.currentRouteName === 'cms-program-wait-media-contents';
        },
        inStatisticsMenu() {
            return this.currentRouteName === 'cms-statistics-channel' ||
                this.currentRouteName === 'cms-statistics-viewer-environment' ||
                this.currentRouteName === 'cms-statistics-storage-usage' ||
                this.currentRouteName === 'cms-statistics-service-logs' ||
                this.currentRouteName === 'cms-statistics-service-usage' ||
                this.currentRouteName === 'cms-chatting-statistics-usage' ||
                this.currentRouteName === 'cms-chatting-statistics-users' ||
                this.currentRouteName === 'cms-chatting-statistics-messages';
        },
        inPreferencesMenu() {
            return (this.currentRouteName.indexOf('cms-preferences') !== -1);
        },

    },
    computed: {
        currentRouteName() {
            return this.$router.currentRoute.name;
        },
    },
};
</script>
